export default __webpack_public_path__ + "static/media/auto-ricksaw.bb1e834d.png";